import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Best Taxi Service in Chennai | Book Cabs Online - BookinIndia",
  description = "BookinIndia offers the best taxi service in Chennai. 24/7 cab booking, airport transfers, outstation trips, and local rides. Safe, reliable, and affordable cabs in Chennai.",
  keywords = "taxi service chennai, cab booking chennai, airport taxi chennai, outstation cabs chennai, local taxi chennai",
  canonicalUrl = "https://www.bookinindia.com/",
  image = "/og-image.jpg",
  schema = null,
  business = null
}) => {
  const siteUrl = "https://www.bookinindia.com";
  const fullUrl = canonicalUrl.startsWith('http') ? canonicalUrl : `${siteUrl}${canonicalUrl}`;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "BookinIndia",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "image": imageUrl,
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": business?.streetAddress || "Address line",
      "addressLocality": business?.city || "Chennai",
      "addressRegion": business?.region || "Tamil Nadu",
      "postalCode": business?.postalCode || "000000",
      "addressCountry": business?.country || "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": business?.latitude || "13.0827",
      "longitude": business?.longitude || "80.2707"
    },
    "priceRange": "INR",
    "telephone": business?.phone || "+91-XXXXXXXXXX"
  };

  const finalSchema = schema || defaultSchema;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="BookinIndia" />
      
      {/* Location-specific meta tags */}
      <meta name="geo.region" content="IN-TN" />
      <meta name="geo.placename" content="Chennai" />
      <meta name="geo.position" content="13.0827;80.2707" />
      <meta name="ICBM" content="13.0827, 80.2707" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BookinIndia" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Alternate language versions */}
      <link rel="alternate" hreflang="en" href={fullUrl} />
      <link rel="alternate" hreflang="ta" href={`${siteUrl}/ta${canonicalUrl}`} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
